/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type MemberManagerListMemberRequest = {
  groupId?: number;
  statuses?: string | null;
  postGroupIds?: string | null;
  perPage?: number | null;
  page?: number | null;
  keyword?: string | null;
  sort?: string | null;
  direction?: MemberManagerListMemberRequest.direction | null;
};

export namespace MemberManagerListMemberRequest {
  export enum direction {
    ASC = "asc",
    DESC = "desc",
  }
}
